import React from 'react';
import { useTranslation } from 'react-i18next';

// EL SELECTOR D'IDIOMA.
//
// El 24/08/2026 es va decidir no posar-ne cap: l'aplicació anava en anglès i només hi havia
// traduïdes la pantalla d'entrada, l'administració i la barra. Oferir un canvi d'idioma amb la
// meitat de les pantalles sense traduir hauria estat ensenyar una cosa a mitges.
//
// Des del 25/08/2026 ja no hi ha aquest problema: està tot. L'anglès segueix sent el que surt
// per defecte —és el que hi havia i és el que es va demanar—, però el català és a un clic.
//
// La tria es desa a `localStorage` (ho fa `i18n.js`), o sigui que sobreviu a tancar el navegador.
const IDIOMES = [['en', 'EN'], ['ca', 'CA']];

export default function SelectorIdioma() {
  const { i18n } = useTranslation();
  const actual = i18n.resolvedLanguage || i18n.language;
  return (
    <div className="flex items-center rounded-md border border-gray-200 overflow-hidden"
         role="group" aria-label="Language">
      {IDIOMES.map(([codi, etiqueta]) => (
        <button key={codi} type="button" onClick={() => i18n.changeLanguage(codi)}
          aria-pressed={actual === codi}
          className={`px-2 py-1 text-xs font-semibold transition-colors ${
            actual === codi
              ? 'bg-primary-700 text-white'
              : 'bg-white text-gray-500 hover:bg-gray-50 hover:text-gray-700'}`}>
          {etiqueta}
        </button>
      ))}
    </div>
  );
}
